export default __webpack_public_path__ + "static/media/JingleBellRock.aa83164d.mp3";